import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ResearchPage } from '../pages';

export const NavRoutes = {
    Home: "/",
    Research: "/ricerca",
    WidgetMap: "/widget/mappa",
    Api: "/swagger",
};

export const NavContext = React.createContext(null);

const { Provider } = NavContext;
export const NavProvider = ({ ...props }) => {
    const history = useHistory();
    const location = useLocation();

    const [breadcrumbs, setBreadcrumbs] = useState(JSON.parse(sessionStorage.getItem("breadcrumbs") || "[]"));

    const navigateTo = (route, args) => {
        route = compileRoute(route, args);
        history.push(route);
    }

    const switchTo = (route, args) => {
        route = compileRoute(route, args);
        history.replace(route);
    }

    const getRouteTo = (route, args) => {
        route = compileRoute(route, args);
        return route;
    }

    const goBack = () => {
        history.goBack();
    }

    const compileRoute = (route, args) => {
        if (route.includes(":") && args && args.length > 0) {
            for (let i = 0; i < args.length; i++) {
                let startIndex = route.indexOf(":", 0);
                if (startIndex === -1) break;
                let endIndex = route.indexOf("/", startIndex);
                if (endIndex === -1) endIndex = route.length - 1;
                else endIndex--;
                const token = route.substr(startIndex, (endIndex - startIndex) + 1);
                route = route.replace(token, args[i]);
            }
        }
        return route;
    }

    const setBreadcrumbRoot = (title) => {
        const tokens = [{ title, url: location.pathname }];
        setBreadcrumbs(tokens);
        sessionStorage.setItem("breadcrumbs", JSON.stringify(tokens));
    }

    const setBreadcrumbToken = (title) => {
        const tokens = [].concat(breadcrumbs);
        const token = tokens.find(x => x.url === location.pathname);
        if (token) {
            token.title = title;
            setBreadcrumbs(tokens);
            sessionStorage.setItem("breadcrumbs", JSON.stringify(tokens));
        }
    }

    const addBreadcrumbToken = (title) => {
        let tokens = [].concat(breadcrumbs);
        if (tokens.find(x => x.url === location.pathname)) {
            const index = tokens.findIndex(x => x.url === location.pathname);
            tokens = tokens.slice(0, index + 1);
        } else {
            tokens.push({ title, url: location.pathname });
        }

        setBreadcrumbs(tokens);
        sessionStorage.setItem("breadcrumbs", JSON.stringify(tokens));
    }

    const replaceBreadcrumbToken = (title, newPathname = null, oldPathname = null) => {
        let tokens = [].concat(breadcrumbs);
        if (tokens.find(x => x.url === oldPathname)) {
            const token = tokens.find(x => x.url === oldPathname);
            token.title = title;
            token.url = newPathname ?? oldPathname;
        } else {
            tokens.push({ title, url: newPathname });
        }

        setBreadcrumbs(tokens);
        sessionStorage.setItem("breadcrumbs", JSON.stringify(tokens));
    }

    const clearBreadcrumbs = () => {
        setBreadcrumbs([]);
        sessionStorage.setItem("breadcrumbs", null);
    }

    const [menuItems, setMenuItems] = useState([
        {
            label: "Ricerca",
            routePath: NavRoutes.Home,
            isProtected: false,
            component: ResearchPage,
            onClick: () => switchTo(NavRoutes.Research)
        }
    ]);


    const requireHeaderAndFooter = () => {

        var widgetNoParamPath = NavRoutes.WidgetMap.split(':')[0];
        if (location.pathname.includes(widgetNoParamPath)) {
            return false;
        } else {
            return true;
        }
    }

    return (
        <Provider value={{
            menuItems,
            navigateTo,
            switchTo,
            getRouteTo,
            goBack,
            breadcrumbs,
            setBreadcrumbRoot,
            setBreadcrumbToken,
            addBreadcrumbToken,
            replaceBreadcrumbToken,
            clearBreadcrumbs,
            compileRoute,
            requireHeaderAndFooter
        }}>
            {props.children}
        </Provider>
    );
}